
import { motion } from 'framer-motion';

export default function Loader() {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-obsidian via-cocoa to-obsidian flex items-center justify-center z-50">
      <div className="relative">
        {/* Coffee Bean Animation */}
        <div className="relative w-32 h-32">
          {/* Rotating Coffee Beans */}
          {[0, 1, 2, 3].map((index) => (
            <motion.div
              key={index}
              className="absolute inset-0"
              animate={{ rotate: 360 }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: 'linear',
                delay: index * 0.3
              }}
            >
              <motion.div
                className="absolute top-1/2 left-1/2 w-8 h-12 -ml-4 -mt-6"
                style={{
                  transform: `rotate(${index * 90}deg) translateY(-40px)`
                }}
              >
                <svg viewBox="0 0 40 60" className="w-full h-full">
                  <defs>
                    <linearGradient id={`beanGradient${index}`} x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#C5A021" />
                      <stop offset="50%" stopColor="#8B6914" />
                      <stop offset="100%" stopColor="#C5A021" />
                    </linearGradient>
                  </defs>
                  {/* Coffee Bean Shape */}
                  <ellipse
                    cx="20"
                    cy="30"
                    rx="16"
                    ry="24"
                    fill={`url(#beanGradient${index})`}
                  />
                  {/* Bean Center Line */}
                  <path
                    d="M 20 10 Q 15 30 20 50"
                    stroke="#140B07"
                    strokeWidth="2"
                    fill="none"
                  />
                </svg>
              </motion.div>
            </motion.div>
          ))}

          {/* Center Glow */}
          <motion.div
            className="absolute inset-0 flex items-center justify-center"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.5, 0.8, 0.5]
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }}
          >
            <div className="w-16 h-16 rounded-full bg-gold/20 blur-xl"></div>
          </motion.div>
        </div>

        {/* Loading Text */}
        <motion.div
          className="absolute -bottom-16 left-1/2 transform -translate-x-1/2 whitespace-nowrap"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <motion.p
            className="text-gold text-sm font-syncopate font-bold tracking-widest"
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            BREWING EXCELLENCE
          </motion.p>
        </motion.div>
      </div>
    </div>
  );
}
